import React from "react";
import { connect, ConnectedProps } from 'react-redux';
import { Link } from "react-router-dom";
import { Container, Dropdown, Image, Menu } from "semantic-ui-react";
import * as Core from '../../core';
import { ApplicationState, strings, routes } from '../..';
import userManager from '../userManager';

const connector = connect(
    (state: ApplicationState) => ({ 
        utente: state.core.auth.user!,
        moduli: state.core.moduli,
        anagrafica: state.core.anagrafiche.anagrafica!,
        allowCambioAnagrafica: state.core.anagrafiche.lista.length > 1
    }),
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type UserHeaderComputerProps = PropsFromRedux

class UserHeaderComputer extends React.Component<UserHeaderComputerProps> {
    
    render() {
        const tenantImageSmall = this.props.utente.profile.picture!;
        const tenantName = this.props.utente.profile.tenantName;
        const userName = this.props.utente.profile.email!;

        return (
            <Menu fixed='top' inverted>
                <Container>
                    <Menu.Item as={Link} to={routes.core.main} header>
                        <Image size='mini' src={tenantImageSmall} style={{ marginRight: '1.5em' }} />
                        {tenantName}
                    </Menu.Item>

                    {this.props.moduli.chiamate && this.renderChiamate()}
                    {this.props.moduli.ordini && this.renderOrdini()}
                    {this.props.moduli.archiviazione && this.renderArchiviazione()}

                    <Menu.Menu position="right">
                        <Dropdown simple item text={userName}>
                            <Dropdown.Menu>
                                {this.props.moduli.admin && this.renderAdmin()}
                                {this.props.allowCambioAnagrafica && this.renderCambiaAnagrafica()}
                                <Dropdown.Item icon='log out' text={strings.core.header.logout} onClick={() => userManager.signoutRedirect()} />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Container>
            </Menu>
        );
    }

    renderCambiaAnagrafica = () => (
        <Dropdown.Item icon='building outline' text={strings.core.header.cambioDitta} onClick={this.props.cambiaAnagrafica} />
    )

    renderChiamate = () => {
        return this.props.anagrafica === undefined ?
            <Dropdown simple item text={strings.chiamate.modulo} /> :
            (
                <Dropdown simple item text={strings.chiamate.modulo}>
                    <Dropdown.Menu>
                        {this.props.anagrafica.hardware && 
                            <Dropdown.Item as={Link} to={routes.core.main + routes.chiamate.hardware} icon='print' text={strings.chiamate.hardware.titolo} />}
                        {this.props.anagrafica.software &&
                            <Dropdown.Item as={Link} to={routes.core.main + routes.chiamate.software} icon='computer' text={strings.chiamate.software.titolo} />}
                        <Dropdown.Divider />
                        <Dropdown.Item as={Link} to={routes.core.main + routes.chiamate.elenco} icon='list' text={strings.chiamate.elenco.titolo} />
                    </Dropdown.Menu>
                </Dropdown>
            )
    }

    renderOrdini = () => {
        return this.props.anagrafica === undefined ?
            <Dropdown simple item text={strings.ordini.modulo} /> :
            (
                <Dropdown simple item text={strings.ordini.modulo}>
                    <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={routes.core.main + routes.ordini.materiale} icon='zip' text={strings.ordini.materiale.titolo} />
                        <Dropdown.Divider />
                        <Dropdown.Item as={Link} to={routes.core.main + routes.ordini.elenco} icon='list' text={strings.ordini.elenco.titolo} />
                    </Dropdown.Menu>
                </Dropdown>
            )
    }

    renderArchiviazione = () => (
        <Menu.Item as={Link} to={routes.core.main + routes.archivi.archivi}>{strings.archivi.modulo}</Menu.Item>
    )

    renderAdmin = () => (
        <>
            <Dropdown.Item as={Link} to={routes.core.main + routes.userAdmin.anagrafiche} icon='address book outline' text={strings.userAdmin.anagrafiche.titolo} />
            <Dropdown.Item as={Link} to={routes.core.main + routes.userAdmin.ubicazioni} icon='map marker alternate' text={strings.userAdmin.ubicazioni.titolo} />
            <Dropdown.Divider />
        </>
    )
}

export default connector(UserHeaderComputer);